<script lang="ts" setup>
import ProductQuestionItem from '~/components/supplier/ProductQuestionItem.vue'
import AuthScope from '~/enums/auth-scope'
import { useProductQuestionsStore } from '~/store/product-questions'

const props = defineProps<{
  productId: string | null
}>()

const productQuestionsStore = useProductQuestionsStore()

async function changePage (pageNumber: number): Promise<void> {
  window.scrollTo(0, 0)

  productQuestionsStore.page.number = pageNumber

  await loadData()
}

async function loadData (): Promise<void> {
  await productQuestionsStore.fetchProductQuestions(AuthScope.Client)
}

onMounted(async (): Promise<void> => {
  productQuestionsStore.filter.productId = props.productId
  productQuestionsStore.page.number = 1

  await loadData()
})

onUnmounted(productQuestionsStore.dispose)
</script>

<template>
  <section>
    <template v-if="productQuestionsStore.productQuestionsData.length">
      <div v-for="x in productQuestionsStore.productQuestionsData" :key="x.id" class="mb-9">
        <ProductQuestionItem :product-question-data="x" />
      </div>
    </template>
    <Notification v-else status="info">
      Нет вопросов о&nbsp;товаре.
    </Notification>

    <Pagination
      class="mt-6"
      :current-page="productQuestionsStore.page.number"
      :last-page="productQuestionsStore.totalPages"
      @change-page="changePage"
    />
  </section>
</template>
